import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { RawFile } from "@mapmycustomers/shared/types/File";
import { Labeled } from "@mapmycustomers/ui";

import FileItem from "@app/component/FileUploader/FileItem";

import styles from "./LockedFiles.module.scss";
import messages from "./messages";

interface LockedFilesProps {
  files: RawFile[];
  required?: boolean;
}

const LockedFiles = ({ files, required }: LockedFilesProps) => {
  const intl = useIntl();

  return (
    <Labeled label={intl.formatMessage(messages.filesLabel)} required={required}>
      <div className={styles.restrictedUpload}>
        <span>{intl.formatMessage(messages.fileUploadRestrictedLabel)}</span>
        <span>
          <FontAwesomeIcon icon={faLock} />
        </span>
      </div>
      <div className={styles.attachments}>
        {files.map((file) => (
          <FileItem file={file} fileName={file.name} key={file.id} />
        ))}
      </div>
    </Labeled>
  );
};

export default LockedFiles;
